export default __webpack_public_path__ + "static/char-thumb-10-8541160f4d09321cb0afa50d79379165.png";